import React, { Component } from 'react'
import { createStyles, WithStyles, withStyles, Theme } from '@material-ui/core'
import { CONTENT_TYPE, SOURCE_TYPE, LANGUAGES, JUDICIAL_DOCUMENT, OUTCOME_OF_TRIAL, PHASE_OF_CASE, TYPE_OF_JUDICIAL_DOCUMENT, TYPE_OF_COURT, BOOLEAN_OPTIONS } from '../../Features/AddNewLTDDocument/@types'
import FormGroup, { IFormConfig } from '../FormGroup'
import CONSTANTS from '../../Resources/LTDConstants.json';
import { OApp } from '../../RootReducer/AppReducer';
import _ from 'lodash';
import { TState } from '../../RootReducer';
import { ONewLTDDocument } from '../../Features/AddNewLTDDocument/redux-config';
import { connect } from 'react-redux';
import ChipSelect from '../ChipSelect'
import { METADATA_ACCUSED, METADATA_ALIA_OFACCUSED_NAME, METADATA_ALTERNATIVE_VENDORS_SHORT_CASE_TITLE, METADATA_ALTERNATIVE_VENDORS_SHORT_CASE_TITLE_EN, METADATA_ALTERNATIVE_VENDORS_SHORT_CASE_TITLE_FR, METADATA_AMICUSCURIAE, METADATA_CASE_DOCUMENT_NUMBER, METADATA_CASE_NAME_EN, METADATA_CASE_NAME_FR, METADATA_CASE_NAME_ICC, METADATA_COMPOSITION_OF_CHAMBER, METADATA_COUNSEL_FOR_DEFENCE, METADATA_COUNSEL_FOR_VICTIMS, METADATA_JUDICAL_DOCUMENT, METADATA_KEY_JUDICAL_DOC, METADATA_OUT_COME_OF_TRIAL, METADATA_PARTICIPATINGS_STATES, METADATA_PHASE_OF_CASE, METADATA_PLACE_OF_COURT, METADATA_PRESIDING_JUDGE, METADATA_PROSECUTOR_TEAM, METADATA_RELATED_CASE_NUMBER, METADATA_TYPE_OF_COURT, METADATA_VICTIMS_PARTICIPATION } from '../../Features/Translations/translationKeys.ltd';
import { getListItemActionLabelTranslation } from '../../Features/CLDDocuments/utils';
import { WithTranslationProps, withTranslations } from '../../Features/Translations/withTranslations';


interface IProps extends WithStyles<typeof STYLES>, IStateProps, IDispatchProps { }


interface IStateProps {
    formData: Record<string, any>
    includeIdOptions: Record<string, any>
    appConstants: any

}

interface IDispatchProps {
    setFormField: (key: string, value: any) => void
    confirmationDialog: (msg: string, onConfirm: Function, onCancel: Function) => void,
}



class JudicialDocuments extends Component<IProps & WithTranslationProps> {

    handleChange = (e: any) => {
        if (this.props.setFormField) {
            this.props.setFormField(e.target.name, e.target.value)
        }
    }
    handleSelectChange = (e: any) => {
        if (this.props.setFormField) {
            this.props.setFormField(e.target.name, [e.target.value])
        }
    }
    handleSlect = (key: string, value: any) => {
        if (this.props.setFormField) {
            this.props.setFormField(key, value)
        }
    }

    render() {
        const { classes, formData, appConstants, includeIdOptions, getTranslation } = this.props

        const FORM_CONFIG: IFormConfig[][] = [

            [
                { label: 'Case name (ICC naming convention)', key: 'caseName', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_CASE_NAME_ICC },
            ],
            [
                { label: 'Case name (ICC naming convention - EN)', key: 'caseName_en', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_CASE_NAME_EN },
            ],
            [
                { label: 'Case name (ICC naming convention - FR)', key: 'caseName_fr', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_CASE_NAME_FR },
            ],
            [
                { label: 'Alternative and / or short case title', key: 'alternative', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_ALTERNATIVE_VENDORS_SHORT_CASE_TITLE },
            ],
            [
                { label: 'Alternative and / or short case title (EN)', key: 'alternative_en', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_ALTERNATIVE_VENDORS_SHORT_CASE_TITLE_EN },
            ],
            [
                { label: 'Alternative and / or short case title (FR)', key: 'alternative_fr', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_ALTERNATIVE_VENDORS_SHORT_CASE_TITLE_FR },
            ],
            [
                { label: 'Case/Document number', key: 'caseNumber', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_CASE_DOCUMENT_NUMBER },
            ],
            [
                { label: 'Related case number', key: 'relatedCases', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_RELATED_CASE_NUMBER },
            ],
            [
                { label: 'Key judicial document', key: 'judicialDocumentIds', type: 'multiselect', onChange: this.handleChange, options: _.get(includeIdOptions, 'judicialDocuments'), translationKey: METADATA_KEY_JUDICAL_DOC },
                { label: 'Outcome of trial', key: 'trailOutcome', type: 'select', onChange: this.handleChange, options: _.get(appConstants, 'trialOutcome') || OUTCOME_OF_TRIAL, translationKey: METADATA_OUT_COME_OF_TRIAL },
            ],
            [
                { label: 'Phase of case', key: 'phaseOfCaseIds', type: 'select', onChange: this.handleSelectChange, options: _.get(includeIdOptions, 'phaseOfCases'), translationKey: METADATA_PHASE_OF_CASE },
                { label: 'Type of judicial document', key: 'judicialDocumentType', type: 'select', onChange: this.handleChange, options: _.get(appConstants, 'judicialDocumentType') || TYPE_OF_JUDICIAL_DOCUMENT, translationKey: METADATA_JUDICAL_DOCUMENT },
            ],
            [
                { label: 'Composition of chamber', key: 'chamberComposition', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_COMPOSITION_OF_CHAMBER },
            ],
            [
                { label: 'Presiding judge', key: 'presidingJudge', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_PRESIDING_JUDGE },
            ],
            [
                { label: 'Place of court', key: 'placeCourt', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_PLACE_OF_COURT },
            ],
            [
                { label: 'Type of court', key: 'courtType', type: 'select', onChange: this.handleChange, options: _.get(appConstants, 'courtType') || TYPE_OF_COURT, translationKey: METADATA_TYPE_OF_COURT },
                {
                    label: '', key: '1-2', type: 'component', onChange: this.handleChange, component: (
                        <div className="flex-row space-between">
                            <ChipSelect formkey="participatingStates" value={formData['participatingStates']} title={getTranslation(METADATA_PARTICIPATINGS_STATES) || 'Participating states'} onChange={this.handleSlect} options={BOOLEAN_OPTIONS} />
                            <ChipSelect formkey="victimParticipation" value={formData['victimParticipation']} title={getTranslation(METADATA_VICTIMS_PARTICIPATION) || 'Victims participation'} onChange={this.handleSlect} options={BOOLEAN_OPTIONS} />
                        </div>
                    )
                }
            ],
            [
                { label: 'Accused / Defendant', key: 'accusedDefendant', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_ACCUSED },
            ],
            [
                { label: 'Alias of accused’s name', key: 'Alias of accused’s name', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_ALIA_OFACCUSED_NAME },
            ],
            [
                { label: 'Prosecutor’s team / Claimant', key: 'prosecutorClaimant', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_PROSECUTOR_TEAM },
            ],
            [
                { label: 'Counsel for defence', key: 'counselForDefence', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_COUNSEL_FOR_DEFENCE },
            ],
            [
                { label: 'Counsel for victims', key: 'victimsCounsel', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_COUNSEL_FOR_VICTIMS },
            ],
            [
                { label: 'Amicus curiae', key: 'amicusCuriae', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_AMICUSCURIAE },
            ],

        ]

        return (
            <>
                <FormGroup classes={{ root: classes.formContainer }} formData={formData} formItems={FORM_CONFIG} />
            </>
        )
    }
}

const STYLES = (theme: Theme) => createStyles({
    formContainer: {
        [theme.breakpoints.down('sm')]: {
            width: '95vw',
        }
    }
})


const mapStateToProps = (state: TState): IStateProps => ({
    ..._.pick(state.NewLTDDocument, ['formData']),
    appConstants: _.get(state.App, 'appConstants.LtdDoc'),
    includeIdOptions: _.get(state.App, 'ltdIncludeOptions'),
});


const mapDispatchToProps = (dispatch): IDispatchProps => ({
    setFormField: (k: string, v: any) => dispatch(ONewLTDDocument.setFormField(k, v)),
    confirmationDialog: (msg: string, onConfirm: Function, onCancel: Function) => dispatch(OApp.showConfirmationDialog(msg, onConfirm, onCancel)),
})

export default withStyles(STYLES)(connect(mapStateToProps, mapDispatchToProps)(withTranslations(JudicialDocuments)))
